module.exports = __webpack_public_path__ + "media/4x3/dk-eb1416e0.svg";